import uiItems from '@/constants/ui-items/index.constants';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { SkuProductDetailsProps } from '@/types/props/components/skus';
import { SkuEnum } from '@/types/translations/SkuEnum';
import isStringDefined from '@/utilites/is-string-defined';
import {
  getDistilledYear,
  getReleaseDate,
} from '@/utilites/sku/sku.dates.utils';

export default function SkuProductDetails({
  skuBottleSizeInMl,
  skuBrandCountryOfOrigin,
  skuBrandName,
  skuBrandRegion,
  skuCategoryName,
  skuDistilledYear,
  skuReleaseDate,
}: SkuProductDetailsProps) {
  const { translate } = useTypedTranslation<SkuEnum>('sku');

  return (
    <>
      <h2 className="tw-text-textBlack tw-font-semibold tw-text-2xl pb-3 tw-relative max-nine:tw-hidden">
        {translate(SkuEnum.product_details)}
      </h2>
      <br className="max-nine:tw-hidden" />

      <p className="tw-font-plusJakartaSans tw-font-medium tw-text-base tw-text-textblack nine:tw-hidden">
        <strong className="tw-font-plusJakartaSans tw-font-semibold tw-text-lg tw-text-text">
          {translate(SkuEnum['product_details'])}
        </strong>
        <br />
      </p>
      <ul className="tw-flex tw-flex-col tw-gap-2 tw-list-none tw-p-0 tw-m-0 tw-w-full">
        {uiItems.sku.skuDescriptionTabs.map(({ tKey }) => {
          const value =
            tKey === 'details.subCategory'
              ? skuCategoryName
              : tKey === 'details.brand'
                ? skuBrandName
                : tKey === 'details.countrySlashRegion'
                  ? `${skuBrandCountryOfOrigin}/${skuBrandRegion}`
                  : tKey === 'details.size'
                    ? `${skuBottleSizeInMl} ML`
                    : tKey === 'details.release_year'
                      ? getReleaseDate(skuReleaseDate)
                      : tKey === 'details.distilled_year'
                        ? getDistilledYear(skuDistilledYear)
                        : '';
          const translation = translate(tKey as SkuEnum);
          if (value === null || isStringDefined(value) === false) {
            return null;
          }
          return (
            <li
              className="tw-flex tw-items-end tw-text-base tw-text-textBlack tw-font-medium tw-gap-3 max-nine:tw-text-xs-custom"
              key={`${translation}-${value}`}
            >
              <span className="tw-text-nowrap"> {translation}</span>

              <hr className="tw-border-2 tw-border-[#5F6D7E66] tw-border-dashed tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-w-full tw-opacity-100 tw-m-0 tw-p-0 tw-mb-1.5"></hr>
              <span className="tw-text-nowrap">{value}</span>
            </li>
          );
        })}
      </ul>
    </>
  );
}
